import { library } from '@vz/react-util';
export const dispatchPageView = (pageName, extraParam = {}) => {
    try {
        if (typeof (vzdl) !== "undefined" && vzdl?.page?.name) {
            library.importData({ pageName: pageName });
            if (window.vztag) {
                vztag.api.dispatch("pageView", {
                    name: pageName,
                    ...extraParam
                });
            } else {
                // Otherwise, wait until we broadcast that we're ready:
                document.addEventListener("vztagReady", function (pageName) {
                    window.vztag.api.dispatch("pageView", {
                        name: pageName,
                        ...extraParam
                    });
                })
            }
        }
        else {
            /* window.vzdl=vzdl;
             dispatchPageView(pageName); */
        }
    } catch (ex) { }
}
export const dispatchOpenView = (viewName, selector) => {
    try {
        if (window.vztag) {
            vztag.api.dispatch("openView", {
                name: viewName,
                selector: selector
            });
        }
    } catch (ex) { }
}
export const dispatchCloseView = (viewName, selector) => {
    try {
        if (window.vztag) {
            vztag.api.dispatch("closeView", {
                name: viewName,
                selector: selector
            });
        }
    } catch (ex) { }
}

export const dispatchError = (id, message) => {
    try {
        if (window.vztag) {
            vztag.api.dispatch("error", {
                id: id,
                message: message
            });
        } else {
            // Otherwise, wait until we broadcast that we're ready:
            document.addEventListener("vztagReady", function (id, message) {
                window.vztag.api.dispatch("error", {
                    id: id,
                    message: message
                });
            })
        }
    } catch (ex) { }
}

export const dispatchVzdlEvent = (eventValue) => {
    try {
        if (window.vzdl && window.vzdl.event) {
            window.vzdl.event.value = eventValue;
        }
    } catch (ex) { }
}

export const dispatchNotifyEvent = (name, message) => {
    try {
        if (window.vzdl && window.vzdl.target) {
            window.vzdl.target.message = message;
        }
        if (window.vztag) {
            vztag.api.dispatch("notify", {
                name: name,
                message: message,
            });
        }
    } catch (ex) { }
}
